import { chain } from "./fourier.js";

/**
 * @function epiCycles Draws the chain of the K largest terms of a Fourier series, starting at (x, y).
 * @param {String} color CSS color of the chain.
 * @return {p5.Vector} The tip of the chain, i.e. the value of the truncated series.
 */
export function epiCycles(pFIVE, terms, K, time, x, y, rotation, color) {
  const joints = chain(terms, K, time, x, y, rotation);
  const circleColor = pFIVE.color(color);
  circleColor.setAlpha(90);

  pFIVE.noFill();
  pFIVE.strokeWeight(1);
  for (let i = 0; i < joints.length - 1; i++) {
    const joint = joints[i];
    const next = joints[i + 1];
    if (joint.r > 0.5) {
      pFIVE.stroke(circleColor);
      pFIVE.ellipse(joint.x, joint.y, joint.r * 2);
    }
    pFIVE.stroke(color);
    pFIVE.line(joint.x, joint.y, next.x, next.y);
  }
  const tip = joints[joints.length - 1];
  return pFIVE.createVector(tip.x, tip.y); //Returns the total of the sum. i.e. The coordinate to draw.
}
